import { FC, PropsWithChildren } from 'react';
import { cn } from '@/utils/classNames.ts';
import { PropsWithClassName } from '@/types/PropsWithClassName';

const StepFormTitle: FC<PropsWithChildren<PropsWithClassName>> = ({ children, className }) => (
  <h1 className={cn('font-newsreader font-bold text-2xl text-[rgba(0,0,0,0.87)]', className)}>{children}</h1>
);

export default StepFormTitle;
